// A social link is shown only when it points at a real profile, not an empty value or a platform home page.
export const isRealSocial = (url) => {
  try {
    const u = new URL(url);
    return /^https?:$/.test(u.protocol) && u.pathname.replace(/\/+$/, "").length > 1;
  } catch {
    return false;
  }
};
